import BaseComponent from '@js/BaseComponent'
import { breakpoint, onBreakpoint } from '@js/mediaQueries'

/**
 *
 * @extends BaseComponent
 */
class DailyGenArtGrid extends BaseComponent {
    /**
     * Lookup of the default number of items per row for each breakpoint
     */
    getItemsPerRow = () => {
        switch(breakpoint()) {
            case 'xxlarge':
                return 7
            case 'xlarge':
                return 6
            case 'large':
                return 5
            case 'medium':
                return 4
            default:
                return 3
        }
    }

    constructor(element) {
        super(element)

        this.element = element
        this.grid = this.element.querySelector('.grid')
        this.originalSizes = this.element.querySelector('.grid img[sizes]:not([sizes=""])').sizes

        this.updateGrid()

        onBreakpoint(() => {
            this.updateGrid()
        })
    }

    /**
     * Updates the grid corners and width after items are hidden/shown
     */
    updateGrid = () => {
        const children = [...this.element.querySelectorAll('li')].filter(item => getComputedStyle(item).display !== 'none')
        const totalItems = children.length
        const itemsPerRow = this.getItemsPerRow()
        const activeItemsPerRow = Math.min(itemsPerRow, totalItems)
        const rows = Math.ceil(totalItems / activeItemsPerRow)
        const lastIndex = activeItemsPerRow * rows
        const firstItemLastRowIndex = lastIndex - activeItemsPerRow + 1

        if (totalItems < itemsPerRow) {
            const itemGridToShow = Math.max(3, totalItems)
            this.grid.style.setProperty('--grid-columns', itemGridToShow)
            this.grid.style.setProperty('--scale', 1.1 - ((7 - itemGridToShow) * 0.015))
            children.forEach(child => {
                const img = child.querySelector('img')
                img.sizes = [
                    `(min-width: 1600px) ${Math.ceil(1100 / itemGridToShow)}px`,
                    `(min-width: 1200px) ${Math.ceil(900 / itemGridToShow)}px`,
                    `(min-width: 768px) ${Math.ceil(80 / itemGridToShow)}vw`,
                    `(min-width: 480px) ${Math.ceil(85 / itemGridToShow)}vw`,
                    `${Math.ceil(90 / itemGridToShow)}vw`
                ].join(', ')
            })
        } else {
            this.grid.style.removeProperty('--grid-columns')
            this.grid.style.removeProperty('--scale')
            children.forEach(child => {
                const img = child.querySelector('img')
                img.sizes = this.originalSizes
            })
        }

        children.forEach(child => {
            child.classList.remove('start-start')
            child.classList.remove('start-end')
            child.classList.remove('end-start')
            child.classList.remove('end-end')
        })

        children[0]?.classList.add('start-start')
        children[activeItemsPerRow - 1]?.classList.add('start-end')
        children[firstItemLastRowIndex - 1]?.classList.add('end-start')
        children[lastIndex - 1]?.classList.add('end-end')
    }
}

DailyGenArtGrid.create('.daily-genart-grid')
